package one.healthium.tasks.data.storages

import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext
import kotlinx.serialization.json.Json
import one.healthium.base.coroutines.IO
import one.healthium.tasks.data.dto.DailyTasksDto
import one.healthium.tasks.data.mapper.DailyTaskMapper
import one.healthium.tasks.domain.DailyTaskInfoModel
import one.primehealth.app.BaseAppResourceProvider

internal class TasksInfoStorage(
    private val json: Json,
    private val dailyTaskMapper: DailyTaskMapper,
    private val appResourceProvider: BaseAppResourceProvider
) {

    suspend fun getTasksInfo(): List<List<DailyTaskInfoModel>> {
        return withContext(Dispatchers.IO) {
            val bytes = appResourceProvider.readBytes("files/daily_tasks/daily_tasks_v1.json")
            val dailyTasksDto = json.decodeFromString<DailyTasksDto>(bytes.decodeToString())
            dailyTaskMapper.dtoToModel(dailyTasksDto)
        }
    }
}